import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    group: '',
    course: '',
    author: '',
    type: '',
    assessment_type: '',
    created_at_from: '',
    created_at_to: '',
    due_date_from: '',
    due_date_to: '',
  },
}

export const assignmentsUI = createSlice({
  name: 'assignmentsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    setAuthor: (state, { payload }) => {
      state.tableFilters.author = payload
    },
    setType: (state, { payload }) => {
      state.tableFilters.type = payload
    },
    setAssessmentType: (state, { payload }) => {
      state.tableFilters.assessment_type = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    setDueDateFromDate: (state, { payload }) => {
      state.tableFilters.due_date_from = payload
    },
    setDueDateToDate: (state, { payload }) => {
      state.tableFilters.due_date_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGroup,
  setCourse,
  setAuthor,
  setType,
  setAssessmentType,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  setDueDateFromDate,
  setDueDateToDate,
  trackActiveFilters,
  clearAllFilters,
} = assignmentsUI.actions

export default assignmentsUI.reducer
